// src/services/alertsService.ts
import { apiClient } from './apiConfig';
import { AlertData } from '../types';

export const getAlerts = async (types: string = ''): Promise<AlertData[]> => {
  const response = await apiClient.get<AlertData[]>(`/get-alerts?types=${types}`);
  return response.data;
};
